import { useEffect, useMemo } from 'react'
import useGlobalSearchContext from 'hooks/GlobalSearch/useGlobalSearchContext'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { GlobalSearchStateActions, GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'

type ReturnType = [
  (action: GlobalSearchAction) => void,
  GlobalSearchState,
]

export function useGlobalMerchandiseSearchContext(
  initialState: GlobalSearchState = GLOBAL_SEARCH_INITIAL_STATE,
  syncWithURLSearchParams?: URLSearchParams,
): ReturnType {
  const merchandiseName = syncWithURLSearchParams?.get('merchandiseName')
  const searchItem = useMemo((): App.SearchMerchandise | undefined => {
    if (merchandiseName) {
      return {
        searchType: 'merchandise',
        value: merchandiseName,
        format: {
          mainText: merchandiseName,
        },
      }
    }
    return undefined
  }, [merchandiseName])

  const { globalSearchState, globalSearchDispatch } = useGlobalSearchContext({
    ...initialState,
    searchVerticals: new Set(['merchandise']),
  })

  // sync search item
  useEffect(() => {
    if (syncWithURLSearchParams) {
      if (searchItem) {
        globalSearchDispatch({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem })
      } else {
        globalSearchDispatch({ type: GlobalSearchStateActions.UNSET_SEARCH_ITEM })
      }
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [searchItem])

  return [
    globalSearchDispatch,
    globalSearchState,
  ]
}
